export const SERVISE_ADDR = 'dev@studyhacker.jp';

export let URL_API;
if (process.env.NODE_ENV === 'production') {
    URL_API = 'https://api.ecprime-shadowing.englishcompany.jp';
} else {
    URL_API = "https://3r0lsqksyi.execute-api.ap-northeast-1.amazonaws.com/dev";
}
